const capabilities = [
  {
    icon: 'ri-building-line',
    title: '主体隔离',
    desc: '多主体数据隔离与授权切换',
  },
  {
    icon: 'ri-shield-user-line',
    title: '权限控制',
    desc: '管理员/财务/关务/只读',
  },
  {
    icon: 'ri-file-list-2-line',
    title: '操作日志',
    desc: '导出/提交/权限变更留痕',
  },
  {
    icon: 'ri-database-2-line',
    title: '资料留存',
    desc: '按版本策略留存，可下载导出',
  },
];

export default function UniversalCapabilities() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">跨域通用能力</h3>
          <p className="text-gray-500 text-sm">安全、可控、可追溯</p>
        </div>
        <div className="grid md:grid-cols-4 gap-6">
          {capabilities.map((cap) => (
            <div
              key={cap.title}
              className="bg-gray-50 border border-gray-200 rounded-2xl p-6 hover:shadow-md transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-white text-gray-600 mb-4">
                <i className={`${cap.icon} text-xl`}></i>
              </div>
              <h4 className="text-base font-bold text-gray-900 mb-2">{cap.title}</h4>
              <p className="text-sm text-gray-600 leading-relaxed">{cap.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}